import React from "react";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { Box, Stack, TextField } from "@mui/material";
import { isValidZip } from "./zipSlotAdsHelpers";

const ZipCodeAddField = ({ onAdd, disabled = false, helperText }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { zip: "" },
    mode: "onChange",
  });

  const submit = handleSubmit((data) => {
    const zip = String(data.zip || "").trim();
    onAdd(zip);
    reset({ zip: "" });
  });

  return (
    <Box component="form" onSubmit={submit} sx={{ mb: 3 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="flex-start">
        <Controller
          name="zip"
          control={control}
          rules={{
            required: "Enter a 5-digit ZIP code",
            validate: (value) =>
              isValidZip(value) || "Enter a valid 5-digit ZIP code",
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ZIP code"
              inputProps={{ inputMode: "numeric", maxLength: 5 }}
              error={!!errors.zip}
              helperText={
                errors.zip?.message ||
                helperText ||
                "Or click a marker on the map"
              }
              disabled={disabled}
              sx={{ minWidth: 220 }}
            />
          )}
        />
        <LoadingButton type="submit" variant="contained" disabled={disabled}>
          Select ZIP
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export default ZipCodeAddField;
